module.exports = __webpack_public_path__ + "static/media/xdd.ddb1ca31.jpg";